// Basic date utilities to be used for simple comparisons.
// This will hopefully allow us to get rid of some day.js checks in big loops

// Based on
// https://github.com/date-fns/date-fns
// https://github.com/date-fns/date-fns/tree/master/src
// https://github.com/date-fns/date-fns/tree/v1/src

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function startOfDay(date: Date) {
  date.setHours(0, 0, 0, 0);
  return date;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameDay(a: Date, b: Date) {
  const dateAStartOfDay = startOfDay(a);
  const dateBStartOfDay = startOfDay(b);

  return dateAStartOfDay.getTime() === dateBStartOfDay.getTime();
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function differenceInDays(a: Date | string, b: Date | string) {
  const dateAStartOfDay = startOfDay(new Date(a));
  const dateBStartOfDay = startOfDay(new Date(b));
  const differenceInMilliseconds = Math.abs(
    dateBStartOfDay.valueOf() - dateAStartOfDay.valueOf(),
  );
  // To get diff in days, divide by number of ms in a day
  return Math.ceil(differenceInMilliseconds / (1000 * 60 * 60 * 24));
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isBefore(a: Date, b: Date) {
  return a.getTime() < b.getTime();
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isAfter(a: Date, b: Date) {
  return a.getTime() > b.getTime();
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameOrBefore(a: string | Date, b: string | Date) {
  return (
    isBefore(new Date(a), new Date(b)) || isSameDay(new Date(a), new Date(b))
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameOrAfter(a: string | Date, b: string | Date) {
  return (
    isAfter(new Date(a), new Date(b)) || isSameDay(new Date(a), new Date(b))
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameOrBeforeToday(a: string | Date) {
  return (
    isBefore(new Date(a), new Date()) || isSameDay(new Date(a), new Date())
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isSameOrAfterToday(a: string | Date) {
  return isAfter(new Date(a), new Date()) || isSameDay(new Date(a), new Date());
}
